import { ref } from "vue";
import { defineStore } from "pinia";
import CryptoJS from "crypto-js";
import jwtDecode from "jwt-decode";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "authentication";

export const useAuthenticationStore = defineStore(
  key,
  () => {
    // state

    const authentication = ref(null);
    const decodedAuthentication = ref(null);

    // actions

    const set = (value) => {
      authentication.value = value;
      decodedAuthentication.value = new jwtDecode(value);
    };

    const unset = () => {
      authentication.value = null;
      decodedAuthentication.value = null;
    };

    return { authentication, decodedAuthentication, set, unset };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
